// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R0EbAadwMsAaqfi9MZXX {
  width: 100%;
  background-color: var(--footer-bottom-block-background);
}

.t81Pv6Q7DyE_5jrYDOIq {
  cursor: pointer
}

.t81Pv6Q7DyE_5jrYDOIq:hover {
    -webkit-text-decoration-line: underline;
            text-decoration-line: underline;
  }

.na1xeSQA64rsWDyjv3GB {
  --vertical-padding: 1.5rem;
  --horizontal-padding: 4rem;

  max-width: 90rem;
  margin: 0 auto;
  padding-top: var(--vertical-padding);
  padding-bottom: var(--vertical-padding);
  padding-left: var(--horizontal-padding);
  padding-right: var(--horizontal-padding)
}

.na1xeSQA64rsWDyjv3GB .jEIM9nzYu57hGYgvSfhu {
    display: flex
  }

.na1xeSQA64rsWDyjv3GB .jEIM9nzYu57hGYgvSfhu .C2IbWBBT9vxLpwqnmbLu {
      border-radius: var(--logo-border-radius);
    }

.na1xeSQA64rsWDyjv3GB .jEIM9nzYu57hGYgvSfhu .hvL9wJkQlFPBLPfi6p6M {
      display: flex;
    }

.WOHHWnuCmDIzF5DDuYtY {
  display: none;
}

@media only screen and
  (min-width: 1280px) {
    .na1xeSQA64rsWDyjv3GB .D46SoQNaV9KfFZcvLzlq {
      display: flex;
      justify-content: space-between;
      align-items: center
    }

      .na1xeSQA64rsWDyjv3GB .D46SoQNaV9KfFZcvLzlq .jEIM9nzYu57hGYgvSfhu {
        align-items: center
      }

        .na1xeSQA64rsWDyjv3GB .D46SoQNaV9KfFZcvLzlq .jEIM9nzYu57hGYgvSfhu .C2IbWBBT9vxLpwqnmbLu {
          margin-right: 2rem;
        }
          .na1xeSQA64rsWDyjv3GB .D46SoQNaV9KfFZcvLzlq .jEIM9nzYu57hGYgvSfhu .hvL9wJkQlFPBLPfi6p6M .t81Pv6Q7DyE_5jrYDOIq {
            margin-right: 1.5rem;
          }

          .na1xeSQA64rsWDyjv3GB .D46SoQNaV9KfFZcvLzlq .jEIM9nzYu57hGYgvSfhu .hvL9wJkQlFPBLPfi6p6M .t81Pv6Q7DyE_5jrYDOIq:last-of-type {
            margin-right: 0;
          }

      .na1xeSQA64rsWDyjv3GB .D46SoQNaV9KfFZcvLzlq ._NnptBoMWrpFHegnEBHg {
        display: flex;
        align-items: center
      }

        .na1xeSQA64rsWDyjv3GB .D46SoQNaV9KfFZcvLzlq ._NnptBoMWrpFHegnEBHg .Xj5HOMGwAGo5oN9RSvim {
          padding-left: 1.5rem;
        }
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .na1xeSQA64rsWDyjv3GB {
    --horizontal-padding: 3rem
  }

    .na1xeSQA64rsWDyjv3GB .D46SoQNaV9KfFZcvLzlq {
      display: flex;
      justify-content: space-between;
      align-items: center
    }

      .na1xeSQA64rsWDyjv3GB .D46SoQNaV9KfFZcvLzlq .jEIM9nzYu57hGYgvSfhu {
        align-items: center
      }

        .na1xeSQA64rsWDyjv3GB .D46SoQNaV9KfFZcvLzlq .jEIM9nzYu57hGYgvSfhu .C2IbWBBT9vxLpwqnmbLu {
          margin-right: 2rem;
        }
          .na1xeSQA64rsWDyjv3GB .D46SoQNaV9KfFZcvLzlq .jEIM9nzYu57hGYgvSfhu .hvL9wJkQlFPBLPfi6p6M .t81Pv6Q7DyE_5jrYDOIq {
            margin-right: 1.5rem;
          }

          .na1xeSQA64rsWDyjv3GB .D46SoQNaV9KfFZcvLzlq .jEIM9nzYu57hGYgvSfhu .hvL9wJkQlFPBLPfi6p6M .t81Pv6Q7DyE_5jrYDOIq:last-of-type {
            margin-right: 0;
          }

    .na1xeSQA64rsWDyjv3GB .Xj5HOMGwAGo5oN9RSvim {
      text-align: right;
      padding-top: 1.5rem;
    }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .na1xeSQA64rsWDyjv3GB {
    --horizontal-padding: 2rem;

    position: relative
  }

    .na1xeSQA64rsWDyjv3GB .jEIM9nzYu57hGYgvSfhu {
      flex-direction: column
    }

      .na1xeSQA64rsWDyjv3GB .jEIM9nzYu57hGYgvSfhu .C2IbWBBT9vxLpwqnmbLu {
        margin-bottom: 1.25rem;
      }

      .na1xeSQA64rsWDyjv3GB .jEIM9nzYu57hGYgvSfhu .hvL9wJkQlFPBLPfi6p6M {
        flex-direction: column
      }

        .na1xeSQA64rsWDyjv3GB .jEIM9nzYu57hGYgvSfhu .hvL9wJkQlFPBLPfi6p6M .t81Pv6Q7DyE_5jrYDOIq {
          margin-top: 0.5rem;
        }

      .na1xeSQA64rsWDyjv3GB .jEIM9nzYu57hGYgvSfhu .Xj5HOMGwAGo5oN9RSvim {
        padding-top: 1.5rem;
        padding-bottom: 1rem;
      }

    .na1xeSQA64rsWDyjv3GB ._NnptBoMWrpFHegnEBHg {
      position: absolute;
      top: 1.75rem;
      right: var(--horizontal-padding);
    }
}

@media only screen and
  (max-width: 639px) {
  .na1xeSQA64rsWDyjv3GB {
    --horizontal-padding: 1rem;

    position: relative
  }

    .na1xeSQA64rsWDyjv3GB .jEIM9nzYu57hGYgvSfhu {
      flex-direction: column
    }

      .na1xeSQA64rsWDyjv3GB .jEIM9nzYu57hGYgvSfhu .C2IbWBBT9vxLpwqnmbLu {
        margin-bottom: 1.25rem;
      }

      .na1xeSQA64rsWDyjv3GB .jEIM9nzYu57hGYgvSfhu .hvL9wJkQlFPBLPfi6p6M {
        flex-direction: column
      }

        .na1xeSQA64rsWDyjv3GB .jEIM9nzYu57hGYgvSfhu .hvL9wJkQlFPBLPfi6p6M .t81Pv6Q7DyE_5jrYDOIq {
          margin-top: 0.5rem;
        }

      .na1xeSQA64rsWDyjv3GB .jEIM9nzYu57hGYgvSfhu .Xj5HOMGwAGo5oN9RSvim {
        padding-top: 1.5rem;
        padding-bottom: 1rem;
      }

    .na1xeSQA64rsWDyjv3GB ._NnptBoMWrpFHegnEBHg {
      position: absolute;
      top: 1.75rem;
      right: var(--horizontal-padding);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/FooterBottomPart/FooterBottomPart.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,uDAAuD;AACzD;;AAEA;EACE;AAKF;;AAHE;IACE,uCAA+B;YAA/B,+BAA+B;EACjC;;AAGF;EACE,0BAAwB;EACxB,0BAA0B;;EAE1B,gBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,uCAAuC;EACvC,uCAAuC;EACvC;AAaF;;AAXE;IACE;EASF;;AAPE;MACE,wCAAwC;IAC1C;;AAEA;MACE,aAAa;IACf;;AAIJ;EACE,aAAa;AACf;;AAEA;;IAEI;MACE,aAAa;MACb,8BAA8B;MAC9B;IA4BF;;MA1BE;QACE;MAeF;;QAbE;UACE,kBAAkB;QACpB;UAGE;YACE,oBAAkB;UACpB;;UAEA;YACE,eAAe;UACjB;;MAIJ;QACE,aAAa;QACb;MAKF;;QAHE;UACE,oBAAkB;QACpB;AAIR;;AAEA;;;EACE;IACE;EA8BF;;IA5BE;MACE,aAAa;MACb,8BAA8B;MAC9B;IAmBF;;MAjBE;QACE;MAeF;;QAbE;UACE,kBAAkB;QACpB;UAGE;YACE,oBAAkB;UACpB;;UAEA;YACE,eAAe;UACjB;;IAKN;MACE,iBAAiB;MACjB,mBAAiB;IACnB;AAEJ;;AAEA;;;EACE;IACE,0BAA0B;;IAE1B;EA4BF;;IA1BE;MACE;IAkBF;;MAhBE;QACE,sBAAmB;MACrB;;MAEA;QACE;MAKF;;QAHE;UACE,kBAAe;QACjB;;MAGF;QACE,mBAAiB;QACjB,oBAAoB;MACtB;;IAGF;MACE,kBAAkB;MAClB,YAAS;MACT,gCAAgC;IAClC;AAEJ;;AAEA;;EACE;IACE,0BAA0B;;IAE1B;EA4BF;;IA1BE;MACE;IAkBF;;MAhBE;QACE,sBAAmB;MACrB;;MAEA;QACE;MAKF;;QAHE;UACE,kBAAe;QACjB;;MAGF;QACE,mBAAiB;QACjB,oBAAoB;MACtB;;IAGF;MACE,kBAAkB;MAClB,YAAS;MACT,gCAAgC;IAClC;AAEJ","sourcesContent":[".wrapper {\n  width: 100%;\n  background-color: var(--footer-bottom-block-background);\n}\n\n.link {\n  cursor: pointer;\n\n  &:hover {\n    text-decoration-line: underline;\n  }\n}\n\n.footerBottomPart {\n  --vertical-padding: 24px;\n  --horizontal-padding: 64px;\n\n  max-width: 1440px;\n  margin: 0 auto;\n  padding-top: var(--vertical-padding);\n  padding-bottom: var(--vertical-padding);\n  padding-left: var(--horizontal-padding);\n  padding-right: var(--horizontal-padding);\n\n  & .logoAndLinksContainer {\n    display: flex;\n\n    & .logo {\n      border-radius: var(--logo-border-radius);\n    }\n\n    & .linksContainer {\n      display: flex;\n    }\n  }\n}\n\n.hiddenLink {\n  display: none;\n}\n\n@media (--desktop-large) {\n  .footerBottomPart {\n    & .footerBottomPartInnerWrapper {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      & .logoAndLinksContainer {\n        align-items: center;\n\n        & .logo {\n          margin-right: 32px;\n        }\n\n        & .linksContainer {\n          & .link {\n            margin-right: 24px;\n          }\n\n          & .link:last-of-type {\n            margin-right: 0;\n          }\n        }\n      }\n\n      & .socialIconsWithLinksContainer {\n        display: flex;\n        align-items: center;\n\n        & .footerCopyright {\n          padding-left: 24px;\n        }\n      }\n    }\n  }\n}\n\n@media (--desktop-small) {\n  .footerBottomPart {\n    --horizontal-padding: 48px;\n\n    & .footerBottomPartInnerWrapper {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      & .logoAndLinksContainer {\n        align-items: center;\n\n        & .logo {\n          margin-right: 32px;\n        }\n\n        & .linksContainer {\n          & .link {\n            margin-right: 24px;\n          }\n\n          & .link:last-of-type {\n            margin-right: 0;\n          }\n        }\n      }\n    }\n\n    & .footerCopyright {\n      text-align: right;\n      padding-top: 24px;\n    }\n  }\n}\n\n@media (--tablet) {\n  .footerBottomPart {\n    --horizontal-padding: 32px;\n\n    position: relative;\n\n    & .logoAndLinksContainer {\n      flex-direction: column;\n\n      & .logo {\n        margin-bottom: 20px;\n      }\n\n      & .linksContainer {\n        flex-direction: column;\n\n        & .link {\n          margin-top: 8px;\n        }\n      }\n\n      & .footerCopyright {\n        padding-top: 24px;\n        padding-bottom: 16px;\n      }\n    }\n\n    & .socialIconsWithLinksContainer {\n      position: absolute;\n      top: 28px;\n      right: var(--horizontal-padding);\n    }\n  }\n}\n\n@media (--mobile) {\n  .footerBottomPart {\n    --horizontal-padding: 16px;\n\n    position: relative;\n\n    & .logoAndLinksContainer {\n      flex-direction: column;\n\n      & .logo {\n        margin-bottom: 20px;\n      }\n\n      & .linksContainer {\n        flex-direction: column;\n\n        & .link {\n          margin-top: 8px;\n        }\n      }\n\n      & .footerCopyright {\n        padding-top: 24px;\n        padding-bottom: 16px;\n      }\n    }\n\n    & .socialIconsWithLinksContainer {\n      position: absolute;\n      top: 28px;\n      right: var(--horizontal-padding);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `R0EbAadwMsAaqfi9MZXX`,
	"link": `t81Pv6Q7DyE_5jrYDOIq`,
	"footerBottomPart": `na1xeSQA64rsWDyjv3GB`,
	"logoAndLinksContainer": `jEIM9nzYu57hGYgvSfhu`,
	"logo": `C2IbWBBT9vxLpwqnmbLu`,
	"linksContainer": `hvL9wJkQlFPBLPfi6p6M`,
	"hiddenLink": `WOHHWnuCmDIzF5DDuYtY`,
	"footerBottomPartInnerWrapper": `D46SoQNaV9KfFZcvLzlq`,
	"socialIconsWithLinksContainer": `_NnptBoMWrpFHegnEBHg`,
	"footerCopyright": `Xj5HOMGwAGo5oN9RSvim`
};
export default ___CSS_LOADER_EXPORT___;
